import types from '../types';

/**
 * @param {types.Filter | types.Select} filter
 * @returns {types.Filter | types.Select}
 */
const getActiveFilterByType = filter => {
    switch (filter.type) {
        case 'checkbox': {
            const activeItems = filter.options.filter(option => option.checked);

            if (activeItems.length) {
                return {
                    ...filter,
                    options: activeItems
                };
            }

            return null;
        }

        case 'select': {
            const activeItems = filter.options.filter(
                option => filter.value === option.value
            );

            if (activeItems.length) {
                return {
                    ...filter,
                    options: activeItems
                };
            }

            return null;
        }

        default:
            return null;
    }
};

/**
 * @param {types.Filter[]} filters
 * @returns {types.Filter[]}
 */
const getActiveFilters = filters => {
    if (!filters || !Array.isArray(filters) || !filters.length) {
        return [];
    }

    return filters.map(getActiveFilterByType).filter(Boolean);
};

export default getActiveFilters;
